import { appendQueryParams } from "../../util/urlHelpers";
import constants from "../../constants";

const formatNumbers = (value) => value.toString().padStart(2, "0");

const initAnnouncementCountdown = () => {
    const $announcementBar = $("announcement-countdown");

    if (!$announcementBar.length) return;

    $announcementBar.html(`<i class="icon-clock-stop-watch"></i> ${["00", "00", "00"].join(":")}`);

    $announcementBar.countdown();

    $announcementBar.on("countdown:update", function (evt, time) {
        const { days, hour, min, sec } = time;
        const daysView                 =`${days ? days + "D " : ""}`;

        const countdownTime = [
            formatNumbers(hour),
            formatNumbers(min),
            formatNumbers(sec),
        ];

        $(this).html(
            `<i class="icon-clock-stop-watch"></i> ${daysView}${countdownTime.join(":")}`
        );
    });

    $announcementBar.on("countdown:finished", function () {
        $(this).closest(".js-announcement-slide").remove();
    });
};

const initAnnouncementOffers = () => {
    const $announcementBarProduct = $("announcement-product");

    if (!$announcementBarProduct.length) return;

    $announcementBarProduct.each(function () {
        const $announcementSlide         = $(this).closest("announcement-slide");
        const $announcementSlideCarousel = $(this).closest(".js-announcement-slide");

        const offerUrl = $announcementBarProduct.data("offer-url");

        const offerIds = $announcementSlideCarousel.find(".js-input-hidden-offerIds");

        if (offerUrl && offerIds && offerIds.length) {
            const $cartConflictModal = $(".js-cart-conflict-header-bar-modal");
            const url                = appendQueryParams(offerUrl, {
                source: constants.ADD_PRODUCT_TO_CART_SOURCE.OFFER_BANNER,
                productIdList: offerIds.val()
            });

            $announcementSlide.css("cursor", "pointer");

            $announcementSlide.on("click", function () {
                $announcementSlideCarousel.addClass("announcement-slide-loading");
                console.log("offerUrl", offerUrl);
                $.ajax({
                    url: url,
                    type: "get",
                    dataType: "json"
                }).done(function (response) {
                    if (response.isEmptyCartRequired) {
                        $cartConflictModal.data("url", url);
                        $cartConflictModal.toggleClass("show", true);
                        return;
                    }

                    if (response.isViabilityRequired) {
                        window.location.href = response.viabilityCheckUrl;
                    } else {
                        window.location.href = response.cartUrl;
                    }
                }).always(function () {
                    $announcementSlideCarousel.removeClass("announcement-slide-loading");
                });
            });

            $(".js-cart-conflict-header-bar-submit", $cartConflictModal).on("click", function () {
                $announcementSlideCarousel.addClass("announcement-slide-loading");
                const submitUrl = appendQueryParams($cartConflictModal.data("url"), {
                    emptyCart: true
                });

                $.ajax({
                    url: submitUrl,
                    type: "get",
                    dataType: "json",
                }).done(function (response) {
                    if (response.canAddProductToCart && !response.isViabilityRequired) {
                        window.location.href = response.cartUrl;
                    } else if (response.isViabilityRequired) {
                        window.location.href = response.viabilityCheckUrl;
                    }
                }).always(function () {
                    $announcementSlideCarousel.removeClass("announcement-slide-loading");
                });
            });
        }
    });
};

const setUpConflictWithCartItemsModalHeaderBarListeners = () => {
    const $cartConflictModal = $(".js-cart-conflict-header-bar-modal");

    $(".js-cart-conflict-header-bar-close", $cartConflictModal).on("click", function () {
        $cartConflictModal.toggleClass("show", false);
        const $loadingHeaderBanners = $(".js-announcement-slide.announcement-slide-loading");

        $loadingHeaderBanners.removeClass("announcement-slide-loading");
    });
};

const initializeAnnouncementHeaderBar = () => {
    if (
        !window.$ ||
        !$("announcement-slide") ||
        !$("announcement-slide").length
    ) return;

    setUpConflictWithCartItemsModalHeaderBarListeners();
    initAnnouncementCountdown();
    initAnnouncementOffers();
};

export default initializeAnnouncementHeaderBar;
